import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    wallet: {
        id: 'navigation-menu.wallet',
        defaultMessage: 'Wallet',
    },
    market: {
        id: 'navigation-menu.market',
        defaultMessage: 'Market',
    },
    swap: {
        id: 'navigation-menu.swap',
        defaultMessage: 'Swap',
    },
    cards: {
        id: 'navigation-menu.cards',
        defaultMessage: 'Cards',
    },
    staking: {
        id: 'navigation-menu.staking',
        defaultMessage: 'Staking',
    },
    history: {
        id: 'navigation-menu.history',
        defaultMessage: 'History',
    },
    exchange: {
        id: 'navigation-menu.exchange',
        defaultMessage: 'Exchange',
    },
    switchToDay: {
        id: 'header.switch_to_day',
        defaultMessage: 'Day mode',
    },
    switchToNight: {
        id: 'header.switch_to_night',
        defaultMessage: 'Night mode',
    },
    invite: {
        id: 'header.invite_friends',
        defaultMessage: 'Invite friends',
    },
    logOut: {
        id: 'header.log-out',
        defaultMessage: 'Log out',
    },
    settings: {
        id: 'header.settings',
        defaultMessage: 'Settings',
    },
})
